<div class="grid sm:grid-rows-3 h-full">
    <div id="splash-image" class="sm:row-start-1 sm:row-end-4 sm:z-0 col-start-1 bg-no-repeat bg-cover bg-center" style="min-height: 23rem;"></div>
    <div class="hidden"></div>
    <div class="sm:row-start-2 sm:row-end-3 sm:z-10 sm:w-3/4 col-start-1 justify-self-center self-end" >
        <div *ngIf="splashHTML != null" class="bg-white" [innerHTML]="splashHTML"></div>      
    </div>
</div>

